<div class="flex justify-content-center align-items-center min-h-screen surface-ground p-4">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-4 md:w-6">
        <div class="text-center mb-5">
            <div class="flex align-items-center justify-content-center mb-4">
                <img [src]="'assets/layout/images/logo-dark.png'" style="width: 34px;" class="exception-logo"/>
                <img [src]="'assets/layout/images/appname-dark.png'" style="width: 150px;" class="exception-appname ml-3"/>
            </div>
            <i class="pi pi-lock text-6xl text-red-500"></i>
            <h2 class="text-900 mb-2">Access Denied</h2>
            <p class="text-600 mb-4">You don’t have permission to view this page. Please contact your administrator.</p>
        </div>
        <div class="flex justify-content-center gap-3">
            <button pButton label="Go Back" icon="pi pi-arrow-left" class="p-button-secondary" (click)="goBack()"></button>
            <button pButton label="Dashboard" icon="pi pi-home" class="p-button-primary" (click)="goDashboard()"></button>
        </div>
    </div>
</div>
